import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal, Dialog, Button } from '@oliasoft-open-source/react-ui-library';
import { removeSection, removeAllSections } from 'store/entities/activity-model/activity-model';
import { selectActivityModelLoaders } from 'store/entities/activity-model/selectors';
import translations from 'src/internationalisation/translation-map.json';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';

const SectionDeleteModal = ({
  removeSection,
  removeAllSections,
  setModalVisible,
  projectSectionId,
  setActiveForm,
  projectId,
  isDeleting,
}) => {
  const { t } = useTranslation();
  const onClose = () => setModalVisible(false);
  const onDelete = () => {
    if (projectSectionId) {
      removeSection(projectSectionId, { projectId });
    } else {
      removeAllSections(projectId);
    }

    setModalVisible(isDeleting);
    setActiveForm(null);
  };

  return (
    <Modal visible centered fullScreen>
      <Dialog
        dialog={{
          heading: t(
            projectSectionId ? translations.activityModel_deleteSection : translations.activityModel_deleteAllSections,
          ),
          content: (
            <>
              {t(
                projectSectionId
                  ? translations.activityModel_areYouSureYouWantToDeleteThisSection
                  : translations.activityModel_areYouSureYouWantToDeleteAllSections,
              )}
            </>
          ),
          footer: (
            <>
              <Button
                testId="delete-modal-button-delete"
                label={t(translations.delete)}
                colored
                loading={isDeleting}
                disabled={isDeleting}
                onClick={onDelete}
              />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const { isDeleting } = selectActivityModelLoaders(state);
  return {
    isDeleting,
  };
};
const mapDispatchToProps = {
  removeSection,
  removeAllSections,
};

const Container = withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(SectionDeleteModal), {
  isModal: true,
});

export { Container as SectionDeleteModal };
